<template>
    <div class="signin-bg">
        <Header></Header>
        <!--搜索-->
        <div class="w-1200">
            <div class="serch">
                <!--下拉框区域-->
                <div class="dropdown">
                    <div class="xiala">
                        <span>{{searchActive}}</span>
                        <img src="../assets/search/dow.png" alt=""/>
                        <dl class="dropdown_menu">
                            <b class="top"><i class="top-arrow1"></i><i class="top-arrow2"></i></b>
                            <dd>
                                <a href="javascript:;" @click="selectMenu($event)" data-num='1'>摄影图片</a>
                            </dd>
                            <dd>
                                <a href="javascript:;" @click="selectMenu($event)" data-num='2'>矢量图片</a>
                            </dd>
                            <!--<dd>
                                <a href="javascript:;" @click="selectMenu($event)" data-num='0'>优质视频</a>
                            </dd>-->
                        </dl>
                    </div>
                </div>
                <!--搜索框-->
                <div class="inpt">
                    <!--<img src="../assets/search/xj.png" alt=""/>-->
                    <input type="text" placeholder="  搜索照片、矢量图和视频，多个词注意用空格分隔" v-model="keyword" @keyup.enter="goSearch"/>
                    <img v-if="searchActive !== '优质视频'" src="../assets/search/photo_camera.png" alt="" class="camera-btn" @click="showUplaodBox" />
                </div>
                <!--搜索图标-->
                <div class="icon-scrch" @click.prevent="goSearch">
                    <img src="../assets/search/ss1.png" alt=""/>
                </div>

                <div v-if="uploadBoxShowed" v-loading="reverseSearching" element-loading-text="图片分析中..." element-loading-spinner="el-icon-loading" class="upload-box">
                    <el-upload
                        ref="reverseSearch"
                        drag
                        action=""
                        :auto-upload="false"
                        :on-change="handlePreview"
                        :http-request="reverseSearch"
                        :show-file-list="false"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">拖动图片到这里 或者 <em>点击进行上传</em></div>
                    </el-upload>
                    <div v-if="previewImg" class="search-btn">
                        <div class="search-txt">
                            <img :src="previewImg" height="80">
                            <span>{{ previewImgTitle }}</span>
                        </div>
                        <div>
                            <el-button @click="doReverseSearch">开始搜索</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--搜索条件选择-->
        <div class="continer w-1200" style="padding: 15px 0; font-size: 20px">
            <div style="text-align: left;">
                <span>按图搜索</span>
            </div>
        </div>


        <div class="gjcpubuliu" v-if="!isLoad">
            <div class="w-1190" v-if="!isResult">
                咦，未搜到您要找的图片，
                建议您换个同义关键词或者缩短关键词试试哦
            </div>
            <div class="w-1190" v-if="isResult">
                <!--关键词-->
                <div class="nav-top flbt">
                    <div class="gjc-font">
                        <span>共为您找到</span>
                        <span class="jieguo-num">{{searchList.total}}</span>
                        <span>个作品</span>
                    </div>
                    <!-- <pagination :pcurrentPage='currentPage' :ptotal='searchList.pages' @on-result-change="onResultChange"></pagination> -->
                </div>
                <!--图片瀑布流-->
                <div class="pubu-img">
                    <ul>
                        <li v-for="(item,index) in searchList.image" :key="index" :style="{width:(200/item.height)*item.width + 'px',background:'#bbbbbb'}">
                            <div v-if="item.id === 'image_search'" style="position: relative;" >
                                <img v-lazy="item.link_image" style="border: 4px solid #ff9f00;"/>
                                <span style="display: flex;align-items: center;vertical-align: middle;position:absolute;bottom:-4px;background:#ff9f00;text-align:center;line-height:50px;height:50px;width:100%;font-size:16px;">
                                    <span style="line-height: 18px;display:block;    text-align: center;width: 100%;">上传的图片</span>
                                </span>
                            </div>
                            <div v-else >
                                <router-link  :to="{name:'Photo',query:{id: item.id, mediaType: mediaType}}" target="_blank">
                                    <img v-lazy="item.link_image"/>
                                </router-link>
                            </div>

                        </li>
                    </ul>
                </div>
                <!--上一页下一页-->
                <!-- <pagination class="mt25" :pcurrentPage='currentPage' :ptotal='searchList.pages' :prevnext='true' @on-result-change="onResultChange"></pagination> -->
            </div>
            <!-- <div class="w-1190" v-if="isResult">
                <div class="gjc-btm">
                    <p>关键词</p>
                    <div class="gjc-contbg hd">
                        <ul>
                            <li v-for="(item,index) in searchWord" :key="index">
                                <router-link :to="{name:'Search',query:{keyword:item,mediaType:mediaType}}" target="_blank">{{item}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
        <loading v-if="isLoad"></loading>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header';
    import Footer from './Footer';
    import {getCookie} from "../util/common";
    // import Pagination from '../components/Pagination';
    export default {
        name: 'Register',
        data() {
            return {
                searchActive:'摄影图片',
                orientationTxt:'图片形状',
                mediaTypeTxt:'图片类型',
                raceTxt:'种族筛选',
                personTxt:'其他',
                usageTxt:'适用范围',
                keyword: '',
                fid:'',
                orderBy:'all',
                orientation:'all',
                mediaType: 1,
                race:'0',
                usage:'0',
                person:'',
                currentPage:1,
                searchList:[],
                isLoad:false,
                isResult:false,
                searchWord:[],
                searchList2:[],
                tagListOrientation:false,
                tagListPerson:false,
                tagListRace:false,
                tagListMedia:false,
                uploadBoxShowed: false,
                reverseSearching: false,
                previewImg: '',
                previewImgTitle: '',
                user_name:'',
                user_id:'',
                register_time:'',
                name:'',
                email:'',
                contact_person:'',
            }
        },
        components:{
            Header,
            Footer
            // Pagination
        },
        created() {
           this.fid = this.$route.query.fid
           this.mediaType = this.$route.query.mediaType
            if(this.mediaType == 1){
                this.searchActive = '摄影图片'
            }else if(this.mediaType == 2){
                this.searchActive = '矢量图片'
            }
            window.document.title = "神笔Pro - 按图搜索";
            this.$get('/me')
                .then( res => {
                    if(res.code == 200){
                        this.user_name = res.data.user.user_name
                        this.user_id = res.data.user.id
                        this.register_time = res.data.user.created_at
                        this.name = res.data.user.name
                        this.email = res.data.user.email
                        this.contact_person = res.data.user.contact_person
                    }
                }).catch(error => {
                console.log(error)
            })
        },
        mounted() {
            this.getSearchList()
        },
        methods: {
            prevPage(){
                this.currentPage--;
                this.getSearchList(this.currentPage)
            },
            nextPage(){
                this.currentPage++;
                this.getSearchList(this.currentPage)
            },
            onResultChange(val){
                this.currentPage = val
                this.getSearchList(val)
            },
            selectMenu(e){
                this.searchActive = e.target.innerText
                this.mediaType = e.target.getAttribute('data-num')
            },
            goSearch(){
                let token = getCookie('token')
                if(!token) {
                    this.$router.push('/login')
                    return;
                }
                if(this.keyword && this.user_id){
                    let data2 = {
                        keywords:this.keyword,
                        user_name:this.user_name,
                        user_id:this.user_id,
                        register_time:this.register_time,
                        name:this.name,
                        email:this.email,
                        contact_person:this.contact_person,
                    }
                    this.$post('/es/keywords',data2)
                        .then( res => {
                        }).catch(errors => {
                        console.log(errors);
                    })
                }
                if(this.mediaType > 0){
                    this.$router.push({name:'Search',query:{keyword:this.keyword,mediaType:this.mediaType}})
                }else{
                    this.$router.push({name:'VideoList',query:{keyword:this.keyword}})
                }
            },
            getSearchList(currentPage){
                this.isResult = false
                if(!this.fid){
                    this.$message({
                        message: '请换张图片搜索',
                        type: 'error'
                    });
                    return
                }
                this.isLoad = true
                let data = {
                    fid:this.fid,
                    mediaType:this.mediaType,
                    page:currentPage,
                }
                this.$post('/image/reverse_search',data)
                    .then( res => {
                        this.searchList = { page: 0, pages: 0, perpage: 0, total: 0, image: [] }
                        if(res.code == 200){
                            this.isLoad=false
                            if(res.data.result.image.length > 0){
                                this.isResult = true
                                this.searchList = res.data.result
                            }
                        }else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }

                    }).catch(errors => {
                       console.log(errors);
                })
            },
            showUplaodBox() {
                this.uploadBoxShowed = !this.uploadBoxShowed
            },
            handlePreview(file, fileList) {
                console.log(file, fileList);
                const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
                const isLt5M = file.size / 1024 / 1024 < 5;

                if (!isJPG) {
                    this.$message.error('图片必须是JPG或PNG格式!');
                    return;
                }
                if (!isLt5M) {
                    this.$message.error('图片必须小于5MB!');
                    return;
                }
                const _URL = window.URL || window.webkitURL
                this.previewImg = _URL.createObjectURL(file.raw)
                this.previewImgTitle = file.name
            },
            reverseSearch(file) {
                this.reverseSearching = true
                const formData = new FormData()
                formData.append('image', file.file)
                this.$postByFormData('/image/reverse_search', formData).then(res => {
                    this.reverseSearching = false
                    if (res.data.result) {
                        this.fid = res.data.result
                        this.uploadBoxShowed = false
                        this.getSearchList(1)
                        this.previewImgTitle = ''
                        this.previewImg = ''
                    } else {
                        this.$message({
                            message: '请换张图片',
                            type: 'error'
                        });
                    }
                })
            },
            doReverseSearch() {
                let token = getCookie('token')
                if(!token) {
                    this.$router.push('/login')
                    return;
                }
                this.$refs['reverseSearch'].submit();
            }
        }
    }
</script>


<style scoped>
    body {  font-family: "Source Han Sans CN",Arial,sans-serif;  font-size: 16px;  }
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    a {text-decoration: none;color:#333;  }
    div, b, p, h1, h2, h3, h4, h5, h6,ul, li, dl, dd, header, footer {  margin: 0;  padding: 0;  list-style: none;  }
    em, i, b, strong {font-style: normal;font-weight: normal;}
    .ct{text-align: center;}
    .fl{float: left}
    .fr{float: right}
    .pr{position: relative}
    .pa{position: absolute;z-index: 99}
    .hd{overflow: hidden;}
    .flard{display: flex;justify-content: space-around;}
    .flbt{display: flex;justify-content: space-between;}
    .w-1200{width: 1200px;margin: 0 auto;}
    .w-1190{width: 1190px;margin: 0 auto;}
    .mt25{margin-top: 25px}
    /*ͷ������*/
    img{vertical-align: top;}
    .header .logo{margin-top: 16px;}
    .nav li{margin: 0 20px;text-align: center;}
    .nav li.active::after{content:"";display:block;background: #FF9F00;height: 2px;width:80%;margin: -15px auto 0; }
    .nav li.active{font-weight: 600;}
    .loging .kefu img,.loging .tishi img{margin: 17px 20px 0;}
    .tishi{position: relative;}
    .tishi span.num{position: absolute;background: #E74C3A;border-radius:10px;color: #fff;min-width: 20px;height: 20px;font-size: 14px;text-align: center;line-height: 20px;display: inline-block;top:15px;right: 15px;padding: 0 4px;}
    .loging .user-down img{margin: 30px 10px 0}
    .user-down{cursor: pointer;position: relative;}

    .jiantou{ transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    /*�ײ�*/
    footer{height: 180px;background: #fff;padding: 70px 0 0;}
    footer p{font-size: 12px;color: #999;text-align: center;}
    .serch{background: #f7f7f7;display: flex;justify-content: space-between;height: 50px;border-bottom: 2px solid #1F1F1F; position: relative;}
    .xiala{font-size: 16px;}
    .xiala:hover > .dropdown_menu{display: block}
    .dropdown{width: 140px;text-align: center;line-height: 48px;cursor: pointer;}
    .inpt{width: 950px;padding-right: 10px;position: relative;}
    input{border: none;height: 48px;line-height: 48px;width: 100%;/*padding-left:40px;*/outline:none;font-size: 16px;background: #f7f7f7;}
    input::-webkit-input-placeholder {color:#999999; font-size: 16px; }
    input:-moz-placeholder {color:#999999; font-size: 16px; }
    input::-moz-placeholder {color:#999999;font-size: 16px;  }
    input:-ms-input-placeholder {color:#999999; font-size: 16px; }
    .icon-scrch{width: 110px;text-align: center;cursor: pointer;}
    .icon-scrch img{margin-top: 13px;cursor: pointer;}
    /*������*/
    .xiala img{margin-top: 17px;}
    .inpt img{margin-top: 12px;position: absolute;}
    .dropdown {position: relative;}
    .dropdown_menu {display: none;background: #f7f7f7;position: absolute;top:48px;right: 30px;z-index: 1000;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown_menu dd:hover{background: #e0e0e0;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #f7f7f7 solid;}
    /*��������*/
    .continer{padding: 30px 0 15px;}
    .paixu{width: 200px;}
    .tiaojian{width: 980px;}
    .paixu p{float:left;margin-right: 15px;cursor: pointer;}
    .paixu .act{font-weight: 600; }
    .paixu .act i{display:block;height: 2px;width:28px;margin: 2px auto 0px;background: #000; }
    .tiaojian div.fl{margin-right: 30px;}
    .sxall{cursor: pointer;height: 30px;}
    .sxall p{display: inline-block;}
    .sxall img{vertical-align: middle;margin-left: 5px;}
    .tj-dow{background: #fff;top:30px;left: 0;width:110px;border: 1px solid #ddd;display: none;}
    .tj-dow a{display: block;height: 36px;line-height: 36px;}
    .tj-dow a:hover{background: #ddd;}
    .sxall:hover > .tj-dow{
        display: block;
    }
    .gjcpubuliu{background: #F7F7F7;padding: 30px 0;}
    .nav-top{margin:0 5px 20px;}
    .serch-gjc{display: inline-block;margin-right: 20px;}
    .jieguo-num{font-weight: 600;display: inline-block;margin: 0 3px;}
    .page{font-size: 14px;}
    .page .dqye{width: 50px;border-bottom: 1px solid #000000;text-align: center;font-weight: 600;}
    .zuo img,.you img{width: 14px;height: 14px;cursor: pointer;}
    .you img{transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    .allpage{margin: 0 10px;}
    .pubu-img{
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
    }
    .pubu-img ul{
        display: flex;
        flex-wrap: wrap;
    }
    .pubu-img ul li{
        flex-grow: 1;
        margin: 4px;
        height: 200px;
    }
    .pubu-img ul li:last-child{
        flex-grow: unset;
    }
    .pubu-img ul img{
        height: 200px;
        object-fit: cover;
        max-width: 100%;
        min-width: 100%;
        vertical-align: bottom;
    }
    .btn{width:285px;margin: 0 auto }
    .btn a{display: inline-block;width: 130px;height: 40px;line-height: 40px;border-radius: 23px;text-align: center;border: 1px solid#000;font-size:18px;margin: 0 5px;}
    .page-btm{margin-top: -30px;}
    .gjc-btm{margin-top: 60px;}
    .gjc-btm p{font-size: 18px;font-weight: 600;margin-bottom: 25px;}
    .gjc-contbg a{float:left;background: #fff;height: 30px;line-height: 30px;padding: 0 10px;border-radius: 5px;font-size: 14px;color: #999;margin-right: 8px;margin-bottom: 10px;}

    .ul-tag{
        width: 1200px;
        margin: 0 auto;
        display: flex;
    }
    .ul-tag li{
        margin: 0 5px 10px;
    }
    .ul-tag li span{
        position: relative;
        background-color: #f4f4f5;
        color: #909399;
        display: inline-block;
        width: auto;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        font-size: 14px;
        padding: 0px 30px 0px 15px;
    }
    .ul-tag li span i{
        position: absolute;
        content: 'x';
        display: inline-block;
        font-size: 18px;
        right: 15px;
        cursor: pointer;
    }
    .camera-btn {
        position: absolute;
        top: -3px;
        right: 0;
        cursor: pointer;
        width: 36px;
        height: 36px;
    }
    .upload-box {
        position: absolute;
        top: 45px;
        right: 0;
        width: 500px;
        background: white;
        z-index: 999;
    }
    .upload-box .search-btn {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .upload-box .search-btn .search-txt {
        display: flex;
        align-items: center;
    }
    .upload-box .search-btn .search-txt span {
        margin: 0 8px;
        word-break: break-all;
    }
    .upload-box .search-btn .el-button {
        background: #FF9F00;
        color: white;
        border: 0;
        padding: 12px 20px;
    }
</style>
<style>
.serch .el-upload-dragger {
    width: 500px !important;
    border-radius: 0 !important;
}
.serch .el-upload:focus .el-upload-dragger{border-color:#2e2e2e}
.serch .el-upload-dragger:hover {
    border: 1px dashed #2e2e2e;
}
.serch .el-upload-dragger .el-upload__text em {
    color: #2e2e2e;
    font-weight: bold;
    font-size: 16px;
}
.upload-box .el-loading-spinner i {
    color: #FF9F00;
}
.upload-box .el-loading-spinner .el-loading-text {
    color: #FF9F00;
}
</style>
